import "./Filters.scss";
import { Close, Search } from "@mui/icons-material";
import Form from "../utils/Form";
import { useState } from "react";
import CustomSelect from "../utils/customSelect";
import CustomMultiSelect from "../utils/CustomMultiSelect";
import CustomTabs from "../utils/CustomTabs";
import useWindowDimensions from "../utils/WindowDimensions";
import { Drawer } from "@mui/material";

function HireTalentFilter({open = false, onChange = (e, data) => {}, showHideSetter = (value) => {}}) {
    const { width } = useWindowDimensions();
    const isMobile = () => { return width <= 768; }
    const maxOptions = isMobile() ? 10 : 5;
    const filtered = {
        skills: [],
        experiences: ['1-2 Years', '5-10 Years'],
        categories: [],
        budget: [],
        languages: []
    }
    const [formData, setFormData] = useState(filtered);
    const filters = [
        {
            name: 'experience',
            options: [
                {
                    checked: false,
                    label: 'Under 1 Year',
                    count: 51,
                },
                {
                    checked: true,
                    label: '1-2 Years',
                    count: 23,
                },
                {
                    checked: false,
                    label: '2-5 Years',
                    count: 23,
                },
                {
                    checked: true,
                    label: '5-10 Years',
                    count: 23,
                },
                {
                    checked: false,
                    label: '> 10 Years',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Under 1 Year',
                    count: 51,
                },
                {
                    checked: true,
                    label: '1-2 Years',
                    count: 23,
                },
                {
                    checked: false,
                    label: '2-5 Years',
                    count: 23,
                },
                {
                    checked: true,
                    label: '5-10 Years',
                    count: 23,
                },
                {
                    checked: false,
                    label: '> 10 Years',
                    count: 23,
                }
            ]
        },
        {
            name: 'categories',
            options: [
                {
                    checked: false,
                    label: 'Data Entry',
                    count: 51,
                },
                {
                    checked: true,
                    label: 'Proof Reading',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Video And Animation',
                    count: 23,
                },
                {
                    checked: true,
                    label: 'Music And Audio',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Content Writing',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Data Entry',
                    count: 51,
                },
                {
                    checked: true,
                    label: 'Proof Reading',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Video And Animation',
                    count: 23,
                },
                {
                    checked: true,
                    label: 'Music And Audio',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Content Writing',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Data Entry',
                    count: 51,
                },
                {
                    checked: true,
                    label: 'Proof Reading',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Video And Animation',
                    count: 23,
                },
                {
                    checked: true,
                    label: 'Music And Audio',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Content Writing',
                    count: 23,
                }
            ]
        },
        {
            name: 'budget',
            options: [
                {
                    checked: false,
                    label: 'Any Rate',
                    count: 51,
                },
                {
                    checked: true,
                    label: '< ₹1000',
                    count: 23,
                },
                {
                    checked: false,
                    label: '₹1000-₹5000',
                    count: 23,
                },
                {
                    checked: true,
                    label: '₹5000 - ₹10000',
                    count: 23,
                },
                {
                    checked: false,
                    label: '> 10000',
                    count: 23,
                }
            ]
        },
        {
            name: 'skills',
            options: ['Photoshop', 'Illustrator']
        },
        {
            name: 'languages',
            options: [
                {
                    checked: false,
                    label: 'Tamil',
                    count: 51,
                },
                {
                    checked: true,
                    label: 'Hindi',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Telugu',
                    count: 23,
                },
                {
                    checked: true,
                    label: 'Malayalam',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Kannada',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Tamil',
                    count: 51,
                },
                {
                    checked: true,
                    label: 'Hindi',
                    count: 23,
                },
                {
                    checked: true,
                    label: 'Malayalam',
                    count: 23,
                },
                {
                    checked: false,
                    label: 'Kannada',
                    count: 23,
                }
            ]
        }
    ]
    const wrapWithDrawer = (child) => {
        return isMobile() ? <Drawer anchor="left" open={open} onClose={() => showHideSetter(false)}>
            <Close className="close-icon" onClick={() => showHideSetter(false)} />
            {child}
        </Drawer> : child
    }
    const toFilterTitle = (title, items) => <div className="count-wrp"><p>{title}</p><p>{items?.length || ''}</p></div>
    const onSubmit = () => { console.log(formData); showHideSetter(false); };
    return (
        <>{wrapWithDrawer(
            <div className="filters" >
                <div className="filter-title">Filter</div>
                <div className="filters-wrp">
                    <Form formData={formData}
                        handleInputChange={(e, d) => {
                            const { name, value, checked } = e?.target;
                            if (e.target.type === 'checkbox') {
                                if (checked) {
                                    d[name].push(value);
                                }
                                else {
                                    d[name] = d[name].filter(e => e !== value);
                                }
                            }
                            else {
                                d[name] = value;
                            }
                            onChange(e, d);
                            return d;
                        }} onSubmit={() => { console.log(formData) }}
                        render={(data, onchange) =>
                            <>
                                <div className="all-filters mobile-filters"><CustomTabs disabled={!isMobile()} orientation="vertical" tabs={[
                                    {
                                        label: toFilterTitle('Experience', data?.experiences),
                                        component: <CustomMultiSelect onSubmit={onSubmit} maxOptions={maxOptions} data={data?.experiences} searchable={false} options={filters?.[0]?.options}
                                            title='Experiences' name='experiences' className="experiences category"
                                            onChange={onchange}
                                        />
                                    },
                                    {
                                        label: toFilterTitle('Categories', data?.categories),
                                        component: <CustomMultiSelect onSubmit={onSubmit} maxOptions={maxOptions} data={data?.categories} options={filters?.[1]?.options}
                                            title='Categories' name='categories' className="categories category"
                                            onChange={onchange}
                                        />
                                    },
                                    {
                                        label: toFilterTitle('Budget', data?.budget),
                                        component: <CustomMultiSelect onSubmit={onSubmit} maxOptions={maxOptions} data={data?.budget} options={filters?.[2]?.options}
                                            title='Budget' name='budget' className="budget category" searchable={false}
                                            onChange={onchange} range={true}
                                        />
                                    },
                                    {
                                        label: toFilterTitle('Skills', data?.skills),
                                        component: <div className="skills category">
                                            <div className="title">Skills</div>
                                            <div className="search-bar">
                                                <CustomSelect
                                                    parent={data}
                                                    prop='skills'
                                                    value={data?.skills}
                                                    renderValue={() => 'Search Skills'}
                                                    multiple={true} outerSelection={true} options={filters?.[3]?.options} onChange={onchange} />
                                                <Search className='icon' />
                                            </div>
                                            <div className="submit-btn" onClick={onSubmit}>Apply</div>
                                        </div>
                                    },
                                    {
                                        label: toFilterTitle('Languages', data?.languages),
                                        component: <CustomMultiSelect onSubmit={onSubmit} maxOptions={maxOptions} data={data?.languages} options={filters?.[4]?.options} title='Languages' name='languages' className="languages category" onChange={onchange} />
                                    }
                                ]} /></div>
                            </>
                        } />
                </div>
            </div>
        )}
        </>
    );
}

export default HireTalentFilter;
